import React, { Component } from 'react';
import Modal from '@material-ui/core/Modal';
import Box from '@material-ui/core/Box';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { makeStyles } from '@material-ui/core/styles';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { FormattedMessage } from 'react-intl';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';
import { ITEM_TIPO_PRODUCTO, ITEM_TIPO_MANO_DE_OBRA } from '../../commons/constants/itemsTipos.js';
import backendStrings from '../../lang/backendStrings.js';

var modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '95%',
    maxWidth: '900px',
    maxHeight: '90vh',
    overflowY: 'auto',
    backgroundColor: '#fff',
    borderRadius: '4px',
    boxShadow: '0 5px 15px rgba(0,0,0,.5)',
    padding: 0,
};

var useStylesWrapper = makeStyles(function() {
    return {
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
    };
});

var TicketDerivadoSeleccionModal = function(props) {
    var classes = useStylesWrapper();
    return <TicketDerivadoSeleccionModalInner classes={classes} {...props} />;
};

class TicketDerivadoSeleccionModalInner extends Component {
    constructor(props) {
        super(props);

        var itemsChecked = {};
        var tareasChecked = {};

        if (props.itemsNoRealizados) {
            props.itemsNoRealizados.forEach(function(item) {
                itemsChecked[item.id] = true;
            });
        }
        if (props.tareasNoRealizadas) {
            props.tareasNoRealizadas.forEach(function(tarea) {
                tareasChecked[tarea.id] = true;
            });
        }

        this.state = {
            titulo: '',
            itemsChecked: itemsChecked,
            tareasChecked: tareasChecked,
            servicioId: null,
            saving: false,
            errors: [],
        };

        this.handleConfirmar = this.handleConfirmar.bind(this);
        this.handleTituloChange = this.handleTituloChange.bind(this);
        this.handleItemCheck = this.handleItemCheck.bind(this);
        this.handleTareaCheck = this.handleTareaCheck.bind(this);
        this.handleServicioChange = this.handleServicioChange.bind(this);
    }

    componentDidUpdate(prevProps) {
        // Error del servidor: mantener modal abierto, resetear saving y mostrar el error
        if (this.props.serverError && this.props.serverError !== prevProps.serverError) {
            this.setState({ saving: false, errors: [this.props.serverError] });
            return;
        }

        if (this.props.open && !prevProps.open) {
            var itemsChecked = {};
            var tareasChecked = {};
            var itemsNoRealizados = this.props.itemsNoRealizados || [];
            var tareasNoRealizadas = this.props.tareasNoRealizadas || [];

            itemsNoRealizados.forEach(function(item) {
                itemsChecked[item.id] = true;
            });
            tareasNoRealizadas.forEach(function(tarea) {
                tareasChecked[tarea.id] = true;
            });

            var serviciosDistintos = this.getServiciosDistintos(itemsChecked, tareasChecked, itemsNoRealizados, tareasNoRealizadas);
            var servicioId = serviciosDistintos.length === 1 ? serviciosDistintos[0].id : null;

            this.setState({
                titulo: '',
                itemsChecked: itemsChecked,
                tareasChecked: tareasChecked,
                servicioId: servicioId,
                saving: false,
                errors: [],
            });
        }
    }

    handleTituloChange(e) {
        this.setState({ titulo: e.target.value });
    }

    handleItemCheck(id) {
        var itemsChecked = Object.assign({}, this.state.itemsChecked);
        itemsChecked[id] = !itemsChecked[id];
        var itemsNoRealizados = this.props.itemsNoRealizados || [];
        var tareasNoRealizadas = this.props.tareasNoRealizadas || [];
        var serviciosDistintos = this.getServiciosDistintos(itemsChecked, this.state.tareasChecked, itemsNoRealizados, tareasNoRealizadas);
        var servicioId = serviciosDistintos.length === 1 ? serviciosDistintos[0].id : (
            serviciosDistintos.some(function(s) { return s.id === this.state.servicioId; }, this) ? this.state.servicioId : null
        );
        this.setState({ itemsChecked: itemsChecked, servicioId: servicioId });
    }

    handleTareaCheck(id) {
        var tareasChecked = Object.assign({}, this.state.tareasChecked);
        tareasChecked[id] = !tareasChecked[id];
        var itemsNoRealizados = this.props.itemsNoRealizados || [];
        var tareasNoRealizadas = this.props.tareasNoRealizadas || [];
        var serviciosDistintos = this.getServiciosDistintos(this.state.itemsChecked, tareasChecked, itemsNoRealizados, tareasNoRealizadas);
        var servicioId = serviciosDistintos.length === 1 ? serviciosDistintos[0].id : (
            serviciosDistintos.some(function(s) { return s.id === this.state.servicioId; }, this) ? this.state.servicioId : null
        );
        this.setState({ tareasChecked: tareasChecked, servicioId: servicioId });
    }

    handleServicioChange(selectedOption) {
        this.setState({ servicioId: selectedOption ? selectedOption.value : null });
    }

    getServiciosDistintos(itemsChecked, tareasChecked, itemsNoRealizados, tareasNoRealizadas) {
        var map = {};
        itemsNoRealizados.forEach(function(item) {
            if (itemsChecked[item.id] && item.servicio_id) {
                map[item.servicio_id] = item.servicio_nombre || String(item.servicio_id);
            }
        });
        tareasNoRealizadas.forEach(function(tarea) {
            if (tareasChecked[tarea.id] && tarea.servicio_id) {
                map[tarea.servicio_id] = tarea.servicio_nombre || String(tarea.servicio_id);
            }
        });
        return Object.keys(map).map(function(id) {
            return { id: parseInt(id, 10), nombre: map[id] };
        });
    }

    handleConfirmar() {
        var errors = [];
        var titulo = this.state.titulo.trim();

        if (!titulo) {
            errors.push('El título del ticket es obligatorio.');
        }

        var itemsSeleccionados = (this.props.itemsNoRealizados || []).filter(function(item) {
            return this.state.itemsChecked[item.id];
        }, this);

        var tareasSeleccionadas = (this.props.tareasNoRealizadas || []).filter(function(tarea) {
            return this.state.tareasChecked[tarea.id];
        }, this);

        if (itemsSeleccionados.length === 0 && tareasSeleccionadas.length === 0) {
            errors.push('Debés seleccionar al menos un ítem o tarea.');
        }

        if (!this.state.servicioId) {
            errors.push('Debés seleccionar el servicio principal del ticket derivado.');
        }

        if (errors.length > 0) {
            this.setState({ errors: errors });
            return;
        }

        this.setState({ saving: true, errors: [] });
        this.props.onConfirm(titulo, itemsSeleccionados, tareasSeleccionadas, this.state.servicioId);
    }

    render() {
        var classes = this.props.classes;
        var itemsNoRealizados = this.props.itemsNoRealizados || [];
        var tareasNoRealizadas = this.props.tareasNoRealizadas || [];

        var trabajaConRepuestos = ConfigBusiness.get('tickets.trabajaConRepuestos.habilitado') === 'true';
        var trabajaConManoDeObra = ConfigBusiness.get('tickets.trabajaConManoDeObra.habilitado') === 'true';

        var itemsProducto = itemsNoRealizados.filter(function(item) {
            return item.tipo && item.tipo.toLowerCase() === ITEM_TIPO_PRODUCTO.toLowerCase();
        });

        var itemsManoDeObra = itemsNoRealizados.filter(function(item) {
            return item.tipo && item.tipo.toLowerCase() === ITEM_TIPO_MANO_DE_OBRA.toLowerCase();
        });

        var mostrarRepuestos = trabajaConRepuestos && itemsProducto.length > 0;
        var mostrarManoDeObra = trabajaConManoDeObra && itemsManoDeObra.length > 0;
        var mostrarTareas = tareasNoRealizadas.length > 0;

        var hayAlgoSeleccionado = itemsNoRealizados.some(function(item) {
            return this.state.itemsChecked[item.id];
        }, this) || tareasNoRealizadas.some(function(tarea) {
            return this.state.tareasChecked[tarea.id];
        }, this);

        var serviciosDisponibles = this.getServiciosDistintos(
            this.state.itemsChecked,
            this.state.tareasChecked,
            itemsNoRealizados,
            tareasNoRealizadas
        );

        var servicioOptions = serviciosDisponibles.map(function(s) {
            return { value: s.id, label: s.nombre };
        });

        var servicioSeleccionado = servicioOptions.find(function(o) {
            return o.value === this.state.servicioId;
        }, this) || null;

        var botonDeshabilitado = this.state.saving || !this.state.titulo.trim() || !hayAlgoSeleccionado || !this.state.servicioId;

        return (
            <Modal
                open={this.props.open}
                onClose={this.state.saving ? undefined : this.props.onCancel}
                disableEscapeKeyDown={this.state.saving}
                className={classes.modal}
                BackdropComponent={Backdrop}
                BackdropProps={{ timeout: 500 }}
            >
                <Fade in={this.props.open}>
                    <Box sx={modalStyle}>

                        {/* Header estilo fleet */}
                        <div className="modal-header bg-fleet">
                            <h4 className="modal-title text-white">
                                <i className="las la-clipboard-list align-middle icon-modal-title"></i>
                                {' Generar ticket correctivo derivado'}
                            </h4>
                            <button
                                type="button"
                                className="close text-white"
                                onClick={this.props.onCancel}
                                disabled={this.state.saving}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        {/* Body */}
                        <div className="modal-body modal-grey modal-mh ovf-x-hidden">
                        <form className="form form-horizontal">

                            {this.state.errors.length > 0 && (
                                <div className="alert alert-danger" role="alert">
                                    <ul className="mb-0 pl-3">
                                        {this.state.errors.map(function(e, i) {
                                            return <li key={i}>{backendStrings[e] ? <FormattedMessage {...backendStrings[e]} values={this.props.serverErrorContext || {}} /> : e}</li>;
                                        }, this)}
                                    </ul>
                                </div>
                            )}

                            {/* Datos del ticket */}
                            <div className="card pull-up">
                                <div className="card-content">
                                    <div className="card-body">
                                        <h4 className="form-section mt-2">
                                            <i className="la la-cog"></i> Datos del ticket
                                        </h4>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="derivado_titulo">
                                                        Título <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="derivado_titulo"
                                                        className="form-control"
                                                        value={this.state.titulo}
                                                        onChange={this.handleTituloChange}
                                                        placeholder="Ingresá el título del nuevo ticket..."
                                                        disabled={this.state.saving}
                                                        maxLength={255}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="derivado_servicio">
                                                        Servicio <span className="text-danger">*</span>
                                                    </label>
                                                    <Select
                                                        id="derivado_servicio"
                                                        name="derivado_servicio"
                                                        placeholder={serviciosDisponibles.length === 0
                                                            ? 'Seleccioná al menos un ítem o tarea'
                                                            : 'Seleccioná un servicio...'}
                                                        options={servicioOptions}
                                                        valueKey="value"
                                                        labelKey="label"
                                                        value={servicioSeleccionado}
                                                        onChange={this.handleServicioChange}
                                                        disabled={this.state.saving || serviciosDisponibles.length === 0}
                                                        closeOnSelect={true}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Repuestos */}
                            {mostrarRepuestos && (
                                <div className="card pull-up">
                                    <div className="card-content">
                                        <div className="card-body">
                                            <h4 className="form-section mt-2">
                                                <i className="la la-cubes"></i> Repuestos
                                            </h4>
                                            <div className="table-responsive">
                                                <table className="table table-sm">
                                                    <thead className="thead-fleet">
                                                        <tr>
                                                            <th style={{ width: '40px' }}></th>
                                                            <th>Descripción</th>
                                                            <th>Cantidad</th>
                                                            <th>Servicio</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {itemsProducto.map(function(item) {
                                                            var checked = this.state.itemsChecked[item.id] === true;
                                                            return (
                                                                <tr key={'item-' + item.id}>
                                                                    <td><input type="checkbox" checked={checked} onChange={function() { this.handleItemCheck(item.id); }.bind(this)} disabled={this.state.saving} /></td>
                                                                    <td>{item.descripcion}</td>
                                                                    <td>{item.cantidad}</td>
                                                                    <td>{item.servicio_nombre || ''}</td>
                                                                </tr>
                                                            );
                                                        }, this)}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Mano de Obra */}
                            {mostrarManoDeObra && (
                                <div className="card pull-up">
                                    <div className="card-content">
                                        <div className="card-body">
                                            <h4 className="form-section mt-2">
                                                <i className="la la-wrench"></i> Mano de Obra
                                            </h4>
                                            <div className="table-responsive">
                                                <table className="table table-sm">
                                                    <thead className="thead-fleet">
                                                        <tr>
                                                            <th style={{ width: '40px' }}></th>
                                                            <th>Descripción</th>
                                                            <th>Cantidad</th>
                                                            <th>Servicio</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {itemsManoDeObra.map(function(item) {
                                                            var checked = this.state.itemsChecked[item.id] === true;
                                                            return (
                                                                <tr key={'item-mo-' + item.id}>
                                                                    <td><input type="checkbox" checked={checked} onChange={function() { this.handleItemCheck(item.id); }.bind(this)} disabled={this.state.saving} /></td>
                                                                    <td>{item.descripcion}</td>
                                                                    <td>{item.cantidad}</td>
                                                                    <td>{item.servicio_nombre || ''}</td>
                                                                </tr>
                                                            );
                                                        }, this)}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Tareas */}
                            {mostrarTareas && (
                                <div className="card pull-up">
                                    <div className="card-content">
                                        <div className="card-body">
                                            <h4 className="form-section mt-2">
                                                <i className="la la-check-circle"></i> Tareas
                                            </h4>
                                            <div className="table-responsive">
                                                <table className="table table-sm">
                                                    <thead className="thead-fleet">
                                                        <tr>
                                                            <th style={{ width: '40px' }}></th>
                                                            <th>Tarea</th>
                                                            <th>Servicio</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {tareasNoRealizadas.map(function(tarea) {
                                                            var checked = this.state.tareasChecked[tarea.id] === true;
                                                            return (
                                                                <tr key={'tarea-' + tarea.id}>
                                                                    <td><input type="checkbox" checked={checked} onChange={function() { this.handleTareaCheck(tarea.id); }.bind(this)} disabled={this.state.saving} /></td>
                                                                    <td>{tarea.nombre}</td>
                                                                    <td>{tarea.servicio_nombre || ''}</td>
                                                                </tr>
                                                            );
                                                        }, this)}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Botones */}
                            <div className="text-right mt-2">
                                <button
                                    type="button"
                                    className="btn btn-primary mr-1"
                                    onClick={this.handleConfirmar}
                                    disabled={botonDeshabilitado}
                                >
                                    {this.state.saving
                                        ? <span><i className="la la-spinner la-spin"></i> Creando...</span>
                                        : <span><i className="fa fa-check-circle"></i> Crear ticket derivado</span>
                                    }
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={this.props.onCancel}
                                    disabled={this.state.saving}
                                >
                                    <i className="fa fa-times-circle"></i> Cancelar
                                </button>
                            </div>

                        </form>
                        </div>
                    </Box>
                </Fade>
            </Modal>
        );
    }
}

export default TicketDerivadoSeleccionModal;
